module.exports = __webpack_public_path__ + "static/media/OrderImage1.3ce7f9b1.svg";